module.exports = __webpack_public_path__ + "static/media/copy.b9480f6a.svg";